module.exports = __webpack_public_path__ + "static/media/adventurePhotoIcon.e34ceb87.png";